module.exports = __webpack_public_path__ + "static/media/TelegramLogoDark.053d54a3.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/TelegramLogoDark.svg
// module id = 1157
// module chunks = 0